import directus from "api/services/directus";
import { CopyBlocks } from "custom-types/Directus";
import logger from "lib/logger";
import { filterByCountry } from "utils/finder/directusRequestUtils";

export const getCopyBlock = async (
  collection: string,
  slug: string,
  countryCode = "us",
  isDraft = false
): Promise<CopyBlocks | null> => {
  const defaultCountryCode = "US";

  try {
    const result = await directus.get<CopyBlocks[]>(collection, {
      params: {
        fields: "*,location.country",
        "filter[location][country][_in]": [
          countryCode.toUpperCase(),
          defaultCountryCode,
        ],
        "filter[slug][_eq]": slug,
      },
    });

    const data = filterByCountry(result.data, countryCode).find(
      (datum) => datum.status === (isDraft ? "draft" : "published")
    );

    return (
      data || { copy_block: [], location: { country: countryCode }, status: "" }
    );
  } catch (error) {
    logger.error(error);
    return null;
  }
};
